import React from 'react';

type BizNumberFormats = 'THOUSAND_DELIMITED';
type BizStringFormats = 'UPPERCASE' | 'LOWERCASE';

type BizFormatProps = BizNumberFormatProps | BizStringFormatProps;

const BizFormat = ({ value, format }: BizFormatProps) => {
	if (typeof value === 'number') return <BizNumberFormat value={value} format={format as BizNumberFormats} />;
	if (typeof value === 'string') return <BizStringFormat value={value} format={format as BizStringFormats} />;
	return <>{value}</>;
};

export default BizFormat;

type BizNumberFormatProps = {
	value: number;
	format: BizNumberFormats;
};

export const BizNumberFormat = ({ value, format }: BizNumberFormatProps) => {
	if (!value) return <></>;

	const getFormatted = () => {
		if (format === 'THOUSAND_DELIMITED') {
			return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
		}
	};

	return <>{getFormatted()}</>;
};

type BizStringFormatProps = {
	value: string;
	format: BizStringFormats;
};

export const BizStringFormat = ({ value, format }: BizStringFormatProps) => {
	if (!value) return <></>;
	const getFormatted = () => {
		if (format === 'UPPERCASE') {
			return value.toUpperCase();
		}
		if (format === 'LOWERCASE') {
			return value.toLowerCase();
		}
	};
	return <>{getFormatted()}</>;
};
